<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-model="dialogShow"
    class="items-no-padding personal-edit sidebar-dialog">
    <div class="sidebar-content">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div>
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">
        <div class="content px-6">
          <div class="text-box">
            <div class="text-box-line line-flex-row">
              <div class="text-left">{{$t('User.homeCountryCode')}}</div>
              <div class="line-el"></div>
              <div class="data-right">{{parseCountry}}</div>
            </div>
            <div class="text-box-line line-flex-row">
              <div class="text-left">{{$t('Train.lecturesAddr')}}</div>
              <div class="line-el"></div>
              <div class="data-right">{{detailAddress}}</div>
            </div>
          </div>
          <el-form
            class="elform"
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
          >
            <el-form-item
              :label="$t('proof_of_address')"
              prop="addressImgUrl"
            >
              <upload-img-tips></upload-img-tips>
              <MobileImageUpload
                :value="form.addressImgUrl"
                @input="(url) => { form.addressImgUrl = url }"
                @success="(url) => { form.addressImgUrl = url }"
              >
                <img
                  v-if="form.addressImgUrl"
                  :src="form.addressImgUrl"
                  class="avatar middle"
                >
                <div v-else class="avatar-uploader-btn">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </MobileImageUpload>
            </el-form-item>
          </el-form>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div
      class="footer-sidebar" slot="footer">
      <el-button
        @click="cancelHandle"
        type="text"
        class="calcel-btn"
      >{{$t('cancel')}}</el-button>
      <vs-button
        @click="submitHandle"
        color="primary"
        :disabled="submitLoading"
      >
        <span v-if="submitLoading"><i class="el-icon-loading"></i> </span>
        {{$t('Confirm')}}
      </vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import { limitImageSizeFormat } from "@/utils/common";
import { commitAddressImg } from '@/api/user.js'
// 需要重新联调 确认需求

import { mapGetters } from 'vuex'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: "personalEditDialog",
  components:{
    VuePerfectScrollbar
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    allData:{
      type: Object,
      default(){
        return {}
      }
    },
    parseCountry:{
    },
  },
  data() {
    let _this = this;
    return {
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      title: _this.$t('User.addressVerifi'),

      form: {
        addressImgUrl: '',
      },
      rules: {
        addressImgUrl: [
          { required: true, message: _this.$t('Please_upload'),trigger: 'change' },
        ],
      },

      addressLoading: false,
      submitLoading: false,
    }
  },

  watch: {
    allData:{
      handler(val){
        if(val){
          this.form.addressImgUrl = val.addressImgUrl;
        }
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters(['userInfo']),
    detailAddress(){
      let str = this.allData.homeCity + ' ' + this.allData.homeStreet + ' ' + this.allData.homeAddress;
      return str;
    },
  },
  created(){
  },
  methods: {
    close(){
      this.$emit('close')
    },
    closeHandle() {
      this.close();
    },
    interfaceAjaxSuccess(){
      this.$emit('ajax-success');
    },
    submitHandle(){
      if (this.submitLoading) return;
      if(this.userInfo.custStatus == 10){
        this.$message({
          message: this.$t('Please_activate_the_binding'),
          type: 'warning'
        });
        return
      }
      this.$refs.form.validate((valid) => {
        if(valid){
          let parmas = {
            custId: this.allData.id,
            addressImg : this.form.addressImgUrl,
          };
          this.submitLoading = true;
          commitAddressImg(parmas).then((res) => {
            this.$message({
              message: this.$t('uploadAddressFileSuccessTips'),
              type: 'success'
            });

            this.$emit('ajax-success');
          }).finally(() => {
            this.submitLoading = false;
          });

        }else {
          console.log('error');
        }
      })
    },
    cancelHandle(){
      this.close();
    },
    // 上传图片的限制
    beforeAvatarUpload(file){
      return limitImageSizeFormat(file,this);
    },
    uploadAddressImgUrlHandle(item){

      this.$getBase64(item.file).then(res => {
        let file = this.$base64toFile(res);
        this.addressLoading = true;
        this.$uploadFile(file).then((res) => {
          this.addressLoading = false;
          this.form.addressImgUrl = res.data.data.content[0].url;
        }).catch((err) => {
          this.addressLoading = false;
        })
      });

    },

  },
}
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.personal-edit {
  .content {
    padding-top: 30px;
    .text-box {
      background-color: #F8F8F8;
      padding: 10px;
      border-radius: 6px;
      .text-box-line {
        margin-bottom: 10px;
        flex-wrap: wrap;
        font-size: 14px;
        .text-left {
          color: #A29FAE;
        }
        .data-right {
          color: #6E6B7B;
        }
      }
    }
    .avatar {
      width: 120px;
      height: 70px;
    }
    .avatar-uploader-btn {
      width: 120px;
      height: 70px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: 2px dashed #D8D6DE;
    }
    .elform {
      margin-top: 30px;
    }
  }
}
</style>
<style lang="scss">
.personal-edit {
  .vs-sidebar--items {

  }
  .scroll-area--customizer {
    height: calc(100% - 5rem);
  }
  .vs-sidebar {
    position: fixed;
    z-index: 999;
    .sidebar-content {
    }
  }
  .footer-sidebar {
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
